/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButtonTheme, IconButtonVariantTheme, SternumTheme } from '@sternum/ui';

import { Colors } from '../constants';

import { sizes } from './shared';

export function darkPrimaryTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: Colors.BrandBlueLightest,
    textColor: Colors.BrandBlue,
    borderRadius: '50%',
    border: 'none',

    hoverBackgroundColor: Colors.BrandBlueLight,
    hoverTextColor: Colors.BrandBlue,
    hoverBorderRadius: '50%',
    hoverBorder: 'none',

    disabledBackgroundColor: Colors.GreyDarkest,
    disabledTextColor: Colors.Grey,
    disabledBorderRadius: '50%',
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function darkSecondaryTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.White,
    borderRadius: '6px',
    border: `1px solid ${Colors.GreyDarker}`,

    hoverBackgroundColor: Colors.BrandBlueLight,
    hoverTextColor: Colors.BrandBlue,
    hoverBorderRadius: '6px',
    hoverBorder: `1px solid ${Colors.BrandBlueLight}`,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkest,
    disabledBorderRadius: '6px',
    disabledBorder: `1px solid ${Colors.GreyDarkest}`,

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function darkTertiaryMainTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: `transparent`,
    textColor: Colors.BrandPink,
    borderRadius: '6px',
    border: 'none',

    hoverBackgroundColor: `transparent`,
    hoverTextColor: Colors.BrandPinkDark,
    hoverBorderRadius: '6px',
    hoverBorder: 'none',

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkerMiddle,
    disabledBorderRadius: '6px',
    disabledBorder: 'none',

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function darkTertiarySecondTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.TheLightest,
    borderRadius: '6px',
    border: `1px solid ${Colors.TheLightest}`,

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.BrandBlueLight,
    hoverBorderRadius: '6px',
    hoverBorder: `1px solid ${Colors.BrandBlueLight}`,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkest,
    disabledBorderRadius: '6px',
    disabledBorder: `1px solid ${Colors.GreyDarkest}`,

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function darkTertiaryThirdTheme(theme: SternumTheme): Partial<IconButtonVariantTheme> {
  return {
    backgroundColor: 'transparent',
    textColor: Colors.GreyDarker,
    borderRadius: '6px',
    border: `1px solid ${Colors.GreyDarker}`,

    hoverBackgroundColor: 'transparent',
    hoverTextColor: Colors.TheLightest,
    hoverBorderRadius: '6px',
    hoverBorder: `1px solid ${Colors.TheLightest}`,

    disabledBackgroundColor: 'transparent',
    disabledTextColor: Colors.GreyDarkest,
    disabledBorderRadius: '6px',
    disabledBorder: `1px solid ${Colors.GreyDarkest}`,

    focusColor: Colors.AquaMiddle,

    sizes,
  };
}

export function SBOMDarkIconButtonTheme(theme: SternumTheme): Partial<IconButtonTheme> {
  return {
    primary: darkPrimaryTheme(theme),
    secondary: darkSecondaryTheme(theme),
    // these variants are defined in theme/button/button.d.ts
    'tertiary-main': darkTertiaryMainTheme(theme),
    'tertiary-second': darkTertiarySecondTheme(theme),
    'tertiary-third': darkTertiaryThirdTheme(theme),
  };
}
